export const siteInfo = {
  name: '禁漫天堂',
  tagline: '官方入口与完整使用指南',
  description: '禁漫天堂是广受用户关注的成人漫画平台，本页汇总禁漫天堂的最新访问入口、注册登录方法、内容分类导览及常见问题解答，帮助成熟用户快速找到所需资源，安全、顺畅地使用禁漫天堂全部功能。',
  keywords: '禁漫天堂,禁漫天堂入口,禁漫天堂最新地址,禁漫天堂注册登录,禁漫天堂官网,禁漫天堂访问教程,禁漫天堂内容分类',
  url: 'https://mintown.github.io',
  logo: '禁漫天堂',
  email: 'support@jinmantiantang.com',
  year: 2026,
};

export const navigationLinks = [
  { name: '首页', path: '/' },
  { name: '内容分类', path: '/category' },
  { name: '使用教程', path: '/category/guide' },
  { name: '关于我们', path: '/about' },
];